import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const YourPerksIcon = ({
  title = 'YourPerks',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 30 30" {...props}>
    {/* prettier-ignore */}
    <g fill="none" fillRule="nonzero"><path d="M0 0h30v30H0z"/><path fill="currentColor" d="M15 26.5c6.351 0 11.5-5.149 11.5-11.5S21.351 3.5 15 3.5 3.5 8.649 3.5 15 8.649 26.5 15 26.5zm0 1.5C7.82 28 2 22.18 2 15S7.82 2 15 2s13 5.82 13 13-5.82 13-13 13z"/><path fill="currentColor" d="M15 17.305l2.71 1.425-.517-3.018 2.192-2.137-3.03-.44L15 10.389l-1.355 2.746-3.03.44 2.192 2.137-.517 3.018L15 17.305zM15 19l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L15 7l2.351 4.764 5.257.764-3.804 3.708.898 5.236L15 19z"/></g>
  </CreateIconComponent>
);

export default YourPerksIcon;
